import {
  asyncPersonalCard,
  bindPersonalCard,
  disablePersonAccount,
  getByAccountCode,
  queryPersonAccount,
  unbindPersonalCard,
} from '../services';

export default {
  namespace: 'personalCardManage',
  state: {},
  effects: {
    /**
     * 查询个人账户
     */
    *queryPersonAccount({ payload }, { call }) {
      const result = yield call(queryPersonAccount, payload);
      return result;
    },

    /**
     * 查询银行卡明文账户
     */
    *getByAccountCode({ payload }, { call }) {
      const result = yield call(getByAccountCode, payload);
      return result;
    },

    /**
     * 禁用个人账户
     */
    *disablePersonAccount({ payload }, { call }) {
      const result = yield call(disablePersonAccount, payload);
      return result;
    },

    /**
     * 同步单位个人卡
     */
    *asyncPersonalCard({ payload }, { call }) {
      const result = yield call(asyncPersonalCard, payload);
      return result;
    },

    /**
     * 绑定单位个人卡
     */
    *bindPersonalCard({ payload }, { call }) {
      const result = yield call(bindPersonalCard, payload);
      return result;
    },

    /**
     * 解绑单位个人卡
     */
    *unbindPersonalCard({ payload }, { call }) {
      const result = yield call(unbindPersonalCard, payload);
      return result;
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
